import { aboutMock } from './aboutMock';
import { homeMock } from './homeMock';
import { accountTypesMock } from './accountTypesMock';
import { privacyPolicyMock } from './privacyPolicyMock';
import { termsAndConditionsMock } from './termsAndConditionsMock';
import { affiliatesMock } from './affiliatesMock';
import { tradingMock } from './tradingMock';
import { depositsMock } from './depositsMock';
import { whatIsForexMock } from './whatIsForexMock';
import { cfdTradingMock } from './cfdTradingMock';
import { whatIsCfdTradingMock } from './whatIsCfdTradingMock';
import { whatIsCryptoTradingMock } from './whatIsCryptoTradingMock';
import { cryptoTradingMock } from './cryptoTradingMock';
import { tradingPlatformsMock } from './tradingPlatformsMock';
import { whyUsMock } from './whyUsMock';
import { contactUsMock } from './contactUsMock';
import { feesAndChargesMock } from './feesAndChargesMock';
import { faqMock } from './faqMock';

export const MOCK_PAGES = {
    // 'home': homeMock,
    // 'about': aboutMock,
    // 'account-types': accountTypesMock,
    // 'privacy-policy': privacyPolicyMock,
    // 'terms-and-conditions': termsAndConditionsMock,
    // 'affiliates': affiliatesMock,
    // 'trading': tradingMock,
    // 'deposits-and-withdrawals': depositsMock,
    // 'what-is-forex-trading': whatIsForexMock,
    // 'cfd-trading': cfdTradingMock,
    // 'what-is-cfd-trading': whatIsCfdTradingMock,
    // 'what-is-cryptocurrency-trading': whatIsCryptoTradingMock,
    // 'cryptocurrency-trading': cryptoTradingMock,
    // 'trading-platforms': tradingPlatformsMock,
    // 'why-us': whyUsMock,
    // 'contact-us': contactUsMock,
    // 'fees-and-charges': feesAndChargesMock,
    // 'faq': faqMock
};
